import React from "react";
import { Container, Typography, Box } from "@mui/material";
import Meeting from "../assets/Meeting.png";

export default function AboutSection() {
  

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        {/* === Heading === */}
        <Typography
          variant="h3"
          fontWeight={800}
          mb={5}
          sx={{
            background: "linear-gradient(90deg, #1565c0, #004ba0)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          About Us
        </Typography>

        {/* === Subheading === */}
        <Typography
          variant="h6"
          color="primary"
          mb={3}
          sx={{ opacity: 0.9 }}
        >
          “We Focus On Delivering Value To Our Customers, Investors, And People Community.”
        </Typography>

        {/* === About Text === */}
        <Typography
          variant="body1"
          color="text.secondary"
          mb={3}
          sx={{
            maxWidth: 850,
            mx: "auto",
            lineHeight: 1.7,
            fontSize: "1.05rem",
          }}
        >
          <strong>M/s. NAMAMI INDIA SUPPORT SERVICES Hospitality & Facility Management Pvt. Ltd.</strong> 
          has been a trusted name in the facility management industry since <strong>2019</strong>. 
          With a strong senior leadership team and the support of 
          <strong> 500+ skilled and semi-skilled professionals</strong>, we ensure the efficient execution of operations 
          and the delivery of high-quality services to our clients.
        </Typography>

        {/* === Image === */}
        <Box
          component="img"
          src={Meeting}
          alt="Namami India Team"
          sx={{
            width: { xs: "95%", sm: "85%", md: "70%" },
            mx: "auto",
            borderRadius: 2,
            mb: 4,
            display: "block",
          }}
        />

        {/* === Continued Text === */}
        <Typography
          variant="body1"
          color="text.secondary"
          mb={3}
          sx={{ maxWidth: 850, mx: "auto", lineHeight: 1.7 }}
        >
          NAMAMI was initially conceptualized and formed to cater to Loops’ in-house requirements, managing
          its Pan-India projects with state-of-the-art facilities built to international standards.
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          mb={5}
          sx={{ maxWidth: 850, mx: "auto", lineHeight: 1.7 }}
        >
          Today, NAMAMI is recognized as one of the few companies in the industry providing a comprehensive
          basket of services, blending technology, professional expertise, and a dedicated workforce to
          deliver seamless, world-class solutions that exceed client expectations.
        </Typography>

        {/* === Diagrammatic Services Section === */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 2,
            mb: 6,
            mt: 4,
          }}
        >
          {[
            "Facilities Management",
            "Engineering Solutions",
            "Project Management",
            "In-house Catering Management",
            "Complete Office Support Services",
          ].map((service, index) => (
            <Box
              key={index}
              sx={{
                px: 3,
                py: 2,
                borderRadius: 3,
                background: "linear-gradient(135deg, #e3f2fd, #ffffff)",
                border: "1px solid rgba(25, 118, 210, 0.2)",
                minWidth: { xs: "90%", sm: "40%", md: "30%" },
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                  background: "linear-gradient(135deg, #bbdefb, #e3f2fd)",
                },
              }}
            >
              <Typography
                variant="body1"
                color="primary"
                fontWeight={600}
                sx={{ whiteSpace: "nowrap" }}
              >
                {service}
              </Typography>
            </Box>
          ))}
        </Box>

        
      </Container>
    </Box>
  );
}
